(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-pdp-form]').forEach(function(form){
  var disp = form.querySelector('[data-qty-display]');
  var input = form.querySelector('[data-qty-input]');
  if (!disp || !input) return;
  form.querySelector('[data-qty-decr]').addEventListener('click', function(){
    var v = Math.max(1, parseInt(disp.textContent, 10) - 1);
    disp.textContent = v; input.value = v;
  });
  form.querySelector('[data-qty-incr]').addEventListener('click', function(){
    var v = Math.min(99, parseInt(disp.textContent, 10) + 1);
    disp.textContent = v; input.value = v;
  });
});

  } catch(e) { console.error(e); }
})();
})();
